import { autoinject } from 'aurelia-framework';
import { ServiceWashProductMatrix } from 'models';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class ServiceWashProductMatrixService extends BaseApiService<ServiceWashProductMatrix> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, ServiceWashProductMatrix);
  }
}
